import "./LandingPage.scss";
import LandingPage from "./LandingPage";

export default LandingPage;
